/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { MarketPricingTable, PrimaryButton } from "../../components";
import { useMarketPricing } from "../../store/useMarketPricing";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useNavigate } from "react-router";
import { withAdminPermission } from "../../utils/HOC/withAdminPermission";

function MarketPricingScreen() {
  /** Hooks */
  const { marketPrices, getAllMarketPrices } = useMarketPricing();
  const navigate = useNavigate();

  /** Callbacks */
  const addMarketPrice = () => {
    navigate("/add-market-pricing");
  };

  /** Effects */
  useEffect(() => {
    getAllMarketPrices();
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Materials
        </h1>
        <div className="flex flex-col sm:flex-row items-end sm:items-center">
          <PrimaryButton
            onClick={addMarketPrice}
            label="Add new Stream"
            size="sm"
            className="h-10 mr-4 !bg-droppie-oranje !border-droppie-oranje active:!bg-droppie-oranje-dark"
          />
        </div>
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl shadow-none drop-shadow-none">
        {!marketPrices?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Stream created yet.
          </p>
        ) : (
          <MarketPricingTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(withAdminPermission(MarketPricingScreen));
